import React from 'react';

import { observer } from 'mobx-react';

import { PureComponent } from 'react';
import cn from 'classnames';

import './style.scss';
import withNavigateParams from '../../utils/withNavigateParams';
import { NavigateFunction } from 'react-router';
import chains from '../../stores/chains';
import { Avatar, Spin } from 'antd';
import MagicPlate from '../../controls/MagicPlate';
import TotalTipsCountIcon from '../../assets/icons/TotalTipsCountIcon';
import ReviewsIcon from '../../assets/icons/ReviewsIcon';
import TotalTipsVolumeIcon from '../../assets/icons/TotalTipsVolumeIcon';
import { observable } from 'mobx';
import OwnerChainMetaData from '../../web-types/OwnerChainMetaData';
import handleError, { handleResponseError } from '../../utils/handleError';
import { admin_fetchChain, manager_fetchChainStatistics } from '../../lib/api-web';
import MetricChange from '../../controls/MetricChange';
import LineChart from '../../controls/LineChart';
import AdminChainData from '../../web-types/AdminChainData';
import LineChartTips from '../../controls/LineChartTips';

@observer
class ChainDashboardPage extends PureComponent<{ navigate: NavigateFunction; params: any; state: any }> {
	@observable loading = true;
	@observable showSpinner = false;
	@observable contentVisible = false;
	@observable withdrawalLoading = false;
	@observable chainStatistics!: OwnerChainMetaData;
	@observable data: AdminChainData | null = null;

	firstTime: boolean = true;

	async loadChainData(chainId: number) {
		this.loading = true;
		this.contentVisible = false;
		let spinnerTimeout = null;
		spinnerTimeout = setTimeout(() => {
			spinnerTimeout = null;
			this.showSpinner = true;
		}, 1000);
		try {
			const result = await admin_fetchChain(Number(this.props.params.chainId));
			if (!result.result) {
				handleResponseError(result);
			} else {
				this.data = result.data.data;
			}
			const response = await manager_fetchChainStatistics(chainId);
			if (!response.result) {
				handleResponseError(response);
			} else {
				this.chainStatistics = response.data;
				if (spinnerTimeout) {
					clearTimeout(spinnerTimeout);
				}
				setTimeout(() => {
					this.contentVisible = true;
				}, 100);
			}
		} catch (err) {
			handleError(err);
			return;
		}
		this.loading = false;
		this.showSpinner = false;
	}

	componentDidMount() {
		this.loadChainData(this.props.params.chainId);
	}

	render() {
		if (this.loading) {
			return (
				<div key="one" className="page">
					{this.showSpinner ? <Spin /> : null}
				</div>
			);
		}
		return (
			<div key="two" className={cn('page', { hidden: !this.contentVisible })}>
				<div className="page-head">
					<div className="page-title">
						<h2>Activity of your chain</h2>
					</div>
					<div className="page-actions"></div>
				</div>
				<div>
					<h3
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							marginTop: 10,
						}}
					>
						<div style={{ fontSize: 20 }}>
							Total chain balance: {Number(this.chainStatistics.balance.toFixed(2))} AED
						</div>
					</h3>
				</div>
				<div className="plates">
					<MagicPlate
						className="red"
						onClick={() => {
							this.props.navigate(`/${chains.currentChainId}/tips`);
						}}
					>
						<div className="plate-head">
							<div className="plate-title">Average rating for 30 days</div>
							<div className="plate-icon">
								<TotalTipsCountIcon />
							</div>
						</div>
						<div className="plate-body">
							<MetricChange
								newValue={this.chainStatistics.average_rating_30d}
								oldValue={this.chainStatistics.average_rating_previous_30d}
							/>
						</div>
						<div className="plate-footer">
							<div className="plate-link">Tipz &amp; reviews</div>
							<div className="plate-arrow">
								<ReviewsIcon />
							</div>
						</div>
					</MagicPlate>
					<MagicPlate
						className="blue"
						onClick={() => {
							this.props.navigate(`/${chains.currentChainId}/tips`);
						}}
					>
						<div className="plate-head">
							<div className="plate-title">Total tips volume for 7 days</div>
							<div className="plate-icon">
								<TotalTipsVolumeIcon />
							</div>
						</div>
						<div className="plate-body">
							<MetricChange
								addon="AED"
								newValue={this.chainStatistics.tips_volume_7d}
								oldValue={this.chainStatistics.tips_volume_7d}
							/>
						</div>
						<div className="plate-footer">
							<div className="plate-link">Tipz &amp; reviews</div>
							<div className="plate-arrow">
								<svg
									width="23"
									height="24"
									viewBox="0 0 23 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6.70832 11H13.9821L10.8196 7.71C10.6391 7.52169 10.5377 7.2663 10.5377 7C10.5377 6.7337 10.6391 6.4783 10.8196 6.29C11 6.10169 11.2448 5.99591 11.5 5.99591C11.7552 5.99591 11.9999 6.10169 12.1804 6.29L16.9721 11.29C17.0593 11.3851 17.1277 11.4972 17.1733 11.62C17.2692 11.8635 17.2692 12.1365 17.1733 12.38C17.1277 12.5027 17.0593 12.6149 16.9721 12.71L12.1804 17.71C12.0913 17.8037 11.9853 17.8781 11.8685 17.9289C11.7518 17.9797 11.6265 18.0058 11.5 18.0058C11.3735 18.0058 11.2482 17.9797 11.1314 17.9289C11.0147 17.8781 10.9087 17.8037 10.8196 17.71C10.7297 17.617 10.6585 17.5064 10.6098 17.3846C10.5611 17.2627 10.5361 17.132 10.5361 17C10.5361 16.868 10.5611 16.7373 10.6098 16.6154C10.6585 16.4936 10.7297 16.383 10.8196 16.29L13.9821 13H6.70832C6.45415 13 6.2104 12.8946 6.03068 12.7071C5.85095 12.5196 5.74999 12.2652 5.74999 12C5.74999 11.7348 5.85095 11.4804 6.03068 11.2929C6.2104 11.1054 6.45415 11 6.70832 11Z"
										fill="white"
									/>
								</svg>
							</div>
						</div>
					</MagicPlate>

					<MagicPlate
						className="green"
						onClick={() => {
							this.props.navigate(`/${chains.currentChainId}/tips`);
						}}
					>
						<div className="plate-head">
							<div className="plate-title">Total reviews for 7 days</div>
							<div className="plate-icon">
								<svg
									width="25"
									height="24"
									viewBox="0 0 25 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12.5 22C6.74692 22 2.08337 17.523 2.08337 12C2.08337 6.477 6.74692 2 12.5 2C18.2532 2 22.9167 6.477 22.9167 12C22.9167 17.523 18.2532 22 12.5 22ZM12.5 20C14.7102 20 16.8298 19.1571 18.3926 17.6569C19.9554 16.1566 20.8334 14.1217 20.8334 12C20.8334 9.87827 19.9554 7.84344 18.3926 6.34315C16.8298 4.84285 14.7102 4 12.5 4C10.2899 4 8.17029 4.84285 6.60748 6.34315C5.04468 7.84344 4.16671 9.87827 4.16671 12C4.16671 14.1217 5.04468 16.1566 6.60748 17.6569C8.17029 19.1571 10.2899 20 12.5 20V20ZM11.4615 16L7.04171 11.757L8.51462 10.343L11.4615 13.172L17.3532 7.515L18.8271 8.929L11.4615 16Z"
										fill="white"
									/>
								</svg>
							</div>
						</div>
						<div className="plate-body">
							<MetricChange newValue={this.chainStatistics.tips_count_7d} oldValue={0} />
						</div>
						<div className="plate-footer">
							<div className="plate-link">Detailed statistics</div>
							<div className="plate-arrow">
								<svg
									width="23"
									height="24"
									viewBox="0 0 23 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6.70832 11H13.9821L10.8196 7.71C10.6391 7.52169 10.5377 7.2663 10.5377 7C10.5377 6.7337 10.6391 6.4783 10.8196 6.29C11 6.10169 11.2448 5.99591 11.5 5.99591C11.7552 5.99591 11.9999 6.10169 12.1804 6.29L16.9721 11.29C17.0593 11.3851 17.1277 11.4972 17.1733 11.62C17.2692 11.8635 17.2692 12.1365 17.1733 12.38C17.1277 12.5027 17.0593 12.6149 16.9721 12.71L12.1804 17.71C12.0913 17.8037 11.9853 17.8781 11.8685 17.9289C11.7518 17.9797 11.6265 18.0058 11.5 18.0058C11.3735 18.0058 11.2482 17.9797 11.1314 17.9289C11.0147 17.8781 10.9087 17.8037 10.8196 17.71C10.7297 17.617 10.6585 17.5064 10.6098 17.3846C10.5611 17.2627 10.5361 17.132 10.5361 17C10.5361 16.868 10.5611 16.7373 10.6098 16.6154C10.6585 16.4936 10.7297 16.383 10.8196 16.29L13.9821 13H6.70832C6.45415 13 6.2104 12.8946 6.03068 12.7071C5.85095 12.5196 5.74999 12.2652 5.74999 12C5.74999 11.7348 5.85095 11.4804 6.03068 11.2929C6.2104 11.1054 6.45415 11 6.70832 11Z"
										fill="white"
									/>
								</svg>
							</div>
						</div>
					</MagicPlate>
				</div>
				<div className="plates" style={{ alignItems: 'stretch' }}>
					{this.chainStatistics.best_employee_month ? (
						<div className="employee-plate">
							<h3
								style={{
									fontWeight: '600',
									lineHeight: '140%',
									fontSize: 16,
									marginBottom: 30,
									textAlign: 'center',
								}}
							>
								Most rated employee
								<br />
								of the month
							</h3>
							<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
								<Avatar size={100} src={this.chainStatistics.best_employee_month.avatarUrl} />
								<h4 style={{ marginTop: 10 }}>
									<a
										href={`/${this.chainStatistics.best_employee_month!.placeId}/employees/${
											this.chainStatistics.best_employee_month.id
										}`}
										onClick={e => {
											e.preventDefault();
											this.props.navigate(
												`/${this.chainStatistics.best_employee_month!.placeId}/employees/${
													this.chainStatistics.best_employee_month!.id
												}`,
											);
										}}
									>
										{this.chainStatistics.best_employee_month.firstName}{' '}
										{this.chainStatistics.best_employee_month.lastName}
									</a>
								</h4>
							</div>
							<h3 style={{ fontSize: 24, color: '#00a500', marginTop: 10 }}>
								⭐ {Number(this.chainStatistics.best_employee_rating.toFixed(1))}
							</h3>
						</div>
					) : null}
					{this.chainStatistics.best_employee_tips_month ? (
						<div className="employee-plate">
							<h3
								style={{
									fontWeight: '600',
									lineHeight: '140%',
									fontSize: 16,
									marginBottom: 30,
									textAlign: 'center',
								}}
							>
								Most tipped employee
								<br />
								of the month
							</h3>
							<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
								<Avatar size={100} src={this.chainStatistics.best_employee_tips_month.avatarUrl} />
								<h4 style={{ marginTop: 10 }}>
									<a
										href={`/${this.chainStatistics.best_employee_tips_month!.placeId}/employees/${
											this.chainStatistics.best_employee_tips_month.id
										}`}
										onClick={e => {
											e.preventDefault();
											this.props.navigate(
												`/${this.chainStatistics.best_employee_tips_month!.placeId}/employees/${
													this.chainStatistics.best_employee_tips_month!.id
												}`,
											);
										}}
									>
										{this.chainStatistics.best_employee_tips_month.firstName}{' '}
										{this.chainStatistics.best_employee_tips_month.lastName}
									</a>
								</h4>
							</div>
							<h3 style={{ fontSize: 24, color: '#00a500', marginTop: 10 }}>
								{Number(this.chainStatistics.best_employee_tips_volume.toFixed(1))} AED
							</h3>
						</div>
					) : null}
					<div className="rating-chart">
						<h3 style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 30 }}>
							Average rating for the last 30 days
						</h3>
						<div style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'stretch' }}>
							<LineChart data={this.chainStatistics.daily_rating_last_month} />
						</div>
					</div>
				</div>
				<div className="rating-chart" style={{ marginTop: 20 }}>
					<h3 style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 30 }}>
						Tips volume per day for the last 30 days
					</h3>
					<div style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'stretch' }}>
						<LineChartTips data={this.chainStatistics.daily_tips_last_month} />
					</div>
				</div>
			</div>
		);
	}
}

export default withNavigateParams(ChainDashboardPage);
